import { TbArrowsExchange2 } from 'react-icons/tb';

import { formatIsoToTime12h } from '@/utils/timeFormatter.ts';

import styles from './EventTime.module.scss';

interface EventTimeProps {
  start: string;
  end: string;
}

export const EventTime = ({ start, end }: EventTimeProps) => {
  return (
    <div className={styles.eventTime}>
      <span className={styles.time}>{formatIsoToTime12h(start)}</span>
      <TbArrowsExchange2 className={styles.timeArrow} />
      <span className={styles.time}>{formatIsoToTime12h(end)}</span>
    </div>
  );
};
